import React, { useContext } from 'react'
import { ListGroup } from 'react-bootstrap'
import { NavLink } from 'react-router-dom'

import NavIcon from '../NavIcon'
import NavBadge from '../NavBadge'

import { ConfigContext } from '../../../../../contexts/ConfigContext'
import * as actionType from '../../../../../store/actions'
import useWindowSize from '../../../../../hooks/useWindowSize'
import objectPath from 'object-path'
import { ROUTE_HIS } from 'designer/component/action/Config'
import {TABLET_MIN_WIDTH} from 'config/constant'
import {useTranslation} from 'react-i18next'

const NavItem = ({ layout, item }) => {
  const windowSize = useWindowSize()
  const configContext = useContext(ConfigContext)
  const {t} = useTranslation()
  const { dispatch } = configContext
  const { layoutType } = configContext.state
  const isDarkMenu = layout !== 'horizontal' && ['menu-dark', 'dark'].includes(layoutType)
  const menuStyle = isDarkMenu ? { color: 'inherit' } : {}

  let openNewTab = objectPath.get(item, 'menu.data.openNewTab')

  let itemTitle = item.title
  if (item.icon) {
    itemTitle = <span className="pcoded-mtext" style={menuStyle}>{t(item.title)}</span>
  }

  let itemTarget = ''
  if (item.target) {
    itemTarget = '_blank'
  }

  let url = item.url || ''

  let subContent

  if (openNewTab === 1) {
    if (item.linkType === 'router') {
      if (url.startsWith('/')) {
        url = `${ROUTE_HIS}${url}`
      } else {
        url = `${ROUTE_HIS}/${url}`
      }
    }

    subContent = (
      <a target="_blank" href={url} rel="noopener noreferrer">
        <NavIcon items={item} />
        {itemTitle}
        <NavBadge items={item} />
      </a>
    )
  } else {
    if (item.linkType === 'url') {
      subContent = (
        <a href={url} rel="noopener noreferrer">
          <NavIcon items={item} />
          {itemTitle}
          <NavBadge items={item} />
        </a>
      )
    } else {
      subContent = (
        <NavLink
          to={url}
          className="nav-link d-flex align-items-center"
          activeClassName={isDarkMenu ? 'active text-white' : 'active'}
          exact={true}
          target={itemTarget}
          onClick={() =>
            dispatch({ type: actionType.MENU_CLICK, menuClick: item })
          }
        >
          <NavIcon items={item} />
          {itemTitle}
          <NavBadge items={item} />
        </NavLink>
      )
    }
  }

  let mainContent = ''
  if (layout === 'horizontal') {
    mainContent = (
      <ListGroup.Item
        as="li"
        bsPrefix=" "
        onClick={() => dispatch({ type: actionType.NAV_CONTENT_LEAVE })}
      >
        {subContent}
      </ListGroup.Item>
    )
  } else {
    if (windowSize.width < TABLET_MIN_WIDTH) {
      mainContent = (
        <ListGroup.Item
          as="li"
          bsPrefix=" "
          className={item.classes}
          onClick={() => dispatch({ type: actionType.COLLAPSE_MENU })}
        >
          {subContent}
        </ListGroup.Item>
      )
    } else {
      mainContent = (
        <ListGroup.Item as="li" bsPrefix=" " className={item.classes}>
          {subContent}
        </ListGroup.Item>
      )
    }
  }

  return <React.Fragment>{mainContent}</React.Fragment>
}

export default NavItem
